import { render, staticRenderFns } from "./PermissionsOpportunitiesForm.vue?vue&type=template&id=5e7ead35&scoped=true&"
import script from "./PermissionsOpportunitiesForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsOpportunitiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ead35",
  null
  
)

export default component.exports